// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const volbeat: PokeData = {
  "id": 313,
  "name": "volbeat",
  "height": 7,
  "weight": 177,
  "base_experience": 151,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "quick-attack",
    "double-team",
    "confuse-ray",
    "flash",
    "protect",
    "encore",
    "moonlight",
    "helping-hand",
    "tail-glow",
    "signal-beam",
    "bug-buzz",
    "zen-headbutt",
    "struggle-bug",
    "play-rough",
    "play-nice",
    "infestation"
  ],
  "moves": [
    "tackle",
    "quick-attack",
    "confuse-ray",
    "protect",
    "moonlight",
    "bug-buzz",
    "zen-headbutt",
    "play-rough",
    "pin-rush",
    "leech-steal",
    "sticky-web",
    "pounce",
    "bug-bite"
  ],
  "evolution_chain": {
    "id": 156,
    "item": null,
    "species": [
      {
        "name": "volbeat",
        "order": 339,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 148,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
